var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 42,
    viewBox: "0 0 194 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3669_127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.812 0H0.811523V42H193.812V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3669_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6064 4.96981H30.8307C34.5047 4.96981 37.4819 7.97453 37.4819 11.6823V13.6895C37.4819 13.975 37.7111 14.2064 37.994 14.2064H41.8913C42.1739 14.2064 42.4033 13.975 42.4033 13.6895V9.44381C42.4033 8.58747 42.0669 7.7702 41.4684 7.16625L35.3025 0.943488C34.7011 0.333528 33.9003 0 33.0488 0H20.6064V4.96981Z",
    fill: "url(#paint0_linear_3669_127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6064 37.0302H30.831C34.5049 37.0302 37.4822 34.0255 37.4822 30.3175V22.7842C37.4822 22.4987 37.7113 22.2673 37.9943 22.2673H41.8915C42.1742 22.2673 42.4034 22.4987 42.4034 22.7842V32.5562C42.4034 33.4124 42.0671 34.2298 41.4686 34.8336L35.3028 41.0564C34.7014 41.6664 33.9006 41.9999 33.049 41.9999H20.6064V37.0302Z",
    fill: "url(#paint1_linear_3669_127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6074 0H10.1659C9.32635 0 8.50464 0.345548 7.91217 0.943488L1.74634 7.16625C1.14792 7.7702 0.811523 8.58747 0.811523 9.44081V21H5.73582V11.6823C5.73582 7.97453 8.71305 4.96981 12.3869 4.96981H21.6074V0Z",
    fill: "url(#paint2_linear_3669_127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6074 42H10.1659C9.32635 42 8.50464 41.6543 7.91217 41.0565L1.74634 34.8337C1.14792 34.2298 0.811523 33.4125 0.811523 32.5592V20.3823H5.73582V30.3175C5.73582 34.0255 8.71305 37.0301 12.3869 37.0301H21.6074V42Z",
    fill: "url(#paint3_linear_3669_127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8213 21.996C58.8213 28.4703 62.5521 31.8685 67.4686 31.8685H69.84C73.5419 31.8685 76.9833 29.3782 77.6774 24.5741H74.9879C74.4094 27.2691 72.2983 29.2611 68.6543 29.2611C63.1595 29.2611 61.4242 25.7751 61.4242 21.7618V20.2383C61.4242 16.225 63.1595 12.651 68.6543 12.651C72.0091 12.651 74.1203 14.4087 74.8144 16.8694H77.5908C76.6942 12.5045 73.3395 10.1316 69.84 10.1316H67.4686C62.5521 10.1316 58.8213 13.5298 58.8213 20.004V21.996Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.191 16.8694C86.5136 16.8694 84.5181 17.8947 83.4771 19.3888V10.1316H80.874V31.3998H83.4771V24.0467C83.4771 20.4434 85.9063 19.3888 87.3524 19.3888C89.7816 19.3888 90.8229 20.5019 90.8229 23.1385V31.3998H93.4257V22.6699C93.4257 18.3049 90.5914 16.8694 88.191 16.8694Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.736 27.7964V22.67C109.736 18.3049 107.509 16.8694 104.935 16.8694H102.101C99.2669 16.8694 97.2715 19.0079 97.2715 21.1465H99.8744C99.8744 20.209 100.915 19.3888 102.362 19.3888H104.097C106.671 19.3888 107.076 20.5314 107.134 22.4942H102.419C99.0357 22.4942 96.8955 24.3103 96.8955 26.8884V27.2105C96.8955 30.7846 99.7298 31.8392 102.419 31.8392C104.213 31.8392 106.382 31.3998 107.365 29.8764C107.943 31.3704 109.534 31.3998 110.864 31.3998V28.8804C110.344 28.8804 109.736 28.7046 109.736 27.7964ZM103.258 29.3197C100.539 29.3197 99.4985 28.7339 99.4985 27.0933C99.4985 26.156 100.019 24.7205 103.258 24.7205H107.134V27.0347C107.134 28.9097 104.415 29.3197 103.258 29.3197Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.47 13.647C116.424 13.647 117.205 12.8853 117.205 11.9186C117.205 10.9519 116.424 10.1316 115.47 10.1316C114.515 10.1316 113.734 10.9519 113.734 11.9186C113.734 12.8853 114.515 13.647 115.47 13.647ZM114.168 31.3998H116.771V17.3382H114.168V31.3998Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55 16.8694C126.786 16.8694 124.645 18.0119 123.662 19.6525V17.3382H121.232V31.3998H123.835V24.0467C123.835 20.4433 126.265 19.3888 127.711 19.3888C130.14 19.3888 131.181 20.5019 131.181 23.1385V31.3998H133.784V22.67C133.784 18.3049 130.95 16.8694 128.55 16.8694Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.632 20.7364C156.55 20.7364 147.117 20.7364 147.117 20.7364V23.2556H153.942V23.3143C153.536 26.6246 151.715 29.2611 146.943 29.2611C141.448 29.2611 139.712 25.7751 139.712 21.7618V20.2383C139.712 16.225 141.448 12.651 146.943 12.651C150.876 12.651 152.727 14.4673 153.566 16.9866H156.314C155.301 12.563 152.206 10.1316 148.129 10.1316H145.757C140.84 10.1316 137.11 13.5298 137.11 20.004V21.996C137.11 28.4703 140.84 31.8685 145.757 31.8685H148.129C150.645 31.8685 152.842 30.9603 154.347 29.2319C155.85 27.5036 157.172 24.1883 156.632 20.7364Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.216 10.6003H160.787V31.3999H163.39V23.7538H170.216C173.483 23.7538 176.752 22.3182 176.752 17.1916C176.752 12.3287 173.483 10.6003 170.216 10.6003ZM169.666 21.2344H163.39V13.149H169.666C172.963 13.149 174.004 14.848 174.004 17.1916C174.004 19.5354 172.963 21.2344 169.666 21.2344Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.812 10.6003H177.905V13.1197H184.558V31.3999H187.161V13.1197H193.812V10.6003Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8609 24.3159C17.3218 24.3159 18.506 23.0786 18.506 21.5527C18.506 20.0267 17.3218 18.7896 15.8609 18.7896C14.4 18.7896 13.2158 20.0267 13.2158 21.5527C13.2158 23.0786 14.4 24.3159 15.8609 24.3159Z",
    fill: "#EFEFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7183 24.3159C29.1792 24.3159 30.3634 23.0786 30.3634 21.5527C30.3634 20.0267 29.1792 18.7896 27.7183 18.7896C26.2575 18.7896 25.0732 20.0267 25.0732 21.5527C25.0732 23.0786 26.2575 24.3159 27.7183 24.3159Z",
    fill: "#EFEFE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3669_127",
    x1: 41.2175,
    y1: 14.1843,
    x2: 21.8014,
    y2: 4.20772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C5AE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#509ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3669_127",
    x1: 41.2176,
    y1: 27.8158,
    x2: 21.8014,
    y2: 37.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CF3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3669_127",
    x1: 20.7865,
    y1: 4.69737,
    x2: 6.01799,
    y2: 23.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509ADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26F4D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3669_127",
    x1: 17.1381,
    y1: 37.2105,
    x2: 5.40061,
    y2: 20.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288195,
    stopColor: "#F8CF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F3D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.05720659f09224a876e3a884069ee21c.svg";
export { ForwardRef as ReactComponent };